<template>
   <div class="info-modal"  @click.esc="close">
     <div class="info-modal-body">
        <div class="info-close">
          <img src="@/assets/icon/whiteclose.png" alt="">
        </div>
        <div class="info-info">
          <p>Та "Е-Баримт бүртгэлийн код" гэсэн хэсэгт ebarimt.mn руу нэвтэрч ордог 8 оронтой хэрэглэгчийн кодыг бүртгэж өгсөнөөр таны Бонус картаа ашигласан худалдан авалтын баримт ebarimt.mn-д автоматаар бүртгэгдэх боломжтой болно!</p>
        </div>
     </div>
   </div>
</template>

<script>
export default {
          methods:{
            close(){
                this.$emit('hideInfoMessage');
            },
        }
}
</script>
<style scoped>
.info-modal{
  position: fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  display: flex;
  justify-content: center;
  z-index:2000;
  background: rgba(0,0,0,0.5);
}
.info-modal-body{
  position: absolute;
  top:30%;
  width: 465px;
  height: auto;
  border-radius: 5px;
  background-color: #1660ab;
  display: flex;
  flex-direction: column;
  padding:20px;
}
.info-modal-body div p{
  margin:0;
  font-size:13px;
  color:#fff;
  text-align: center;
  padding-bottom:20px;
}
.info-modal-body .info-close img{
  width:10px;
}

.info-modal-body .info-close{
  width:auto;
  display: flex;
  justify-content: flex-end;
}
.info-modal-body img{
  width:100%;
  cursor: pointer;
}
.info-modal-body .info-info{
  margin-top:10px;
}
@media screen and (max-width: 500px) {
  .info-modal-body{
    margin-top:20%;
  }
}
@media screen and (max-width: 800px) {
  .info-modal-body{
    margin-top:20%;
    width:80%;
  }
}

</style>